import { HttpClient } from '@store/base';
import {
  GetCartCounterRequest,
  GetCartCounterResponse,
} from '../../model/dto/orders';

export class GetCartCounterGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetCartCounterRequest) {
    return await this.httpClient.request<GetCartCounterResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v1/orders/cart-count`,
      body: req,
    });
  }
}
